//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('bulkMail', {
//        templateUrl: 'views/components/views/bulkMail/bulkMail.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'bulkMailService', 'emailCreateService', function ($stateParams, stateService, modalService, translateService, bulkMailService, emailCreateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let bulkMailKeyno = $stateParams.bulkmail_keyno;
            
//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                emailTemplateButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.emailtemplate_keyno = '0' },
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplates') }
//                ],
//                emailTemplateButtons2: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.emailtemplate_keyno = '0' },
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplates') },
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplate', { emailtemplate_keyno: vm.model.edit.emailtemplate_keyno }) }
//                ],
//                edit: {},
//                selectListEmailTemplates: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await bulkMailService.getEdit({ bulkmail_keyno: bulkMailKeyno }))[0];
//            }

//            async function loadEmailTemplates() {
//                vm.model.selectListEmailTemplates = await emailCreateService.listEmailTemplates({ webpage: 'bulkmail' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                bulkMailService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadEmailTemplates();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
